import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PageScaleView } from '../../models/autoScale'
import { AutoScaleOutcome } from '../../shared/constants/auto-scale'
import { RootState } from '../../stores'

export type AutoScaleState = {
    pageView: PageScaleView | null
    isApplying: boolean
    isApplyingNames: boolean
    dimensionsVisible: boolean
}

export const initialAutoScaleState: AutoScaleState = {
    pageView: null,
    isApplying: false,
    isApplyingNames: false,
    dimensionsVisible: false,
}

const autoScaleSlice = createSlice({
    name: 'autoScale',
    initialState: initialAutoScaleState,
    reducers: {
        setAutoScalePageView: (state, { payload }: PayloadAction<PageScaleView | null>) => {
            state.pageView = payload
            // the dimensions toggle lives on the applied indicator, so hide them when the result is not applied
            if (payload?.outcome !== AutoScaleOutcome.AUTO_APPLIED && payload?.outcome !== AutoScaleOutcome.ACCEPTED) {
                state.dimensionsVisible = false
            }
        },
        setAutoScaleApplying: (state, { payload }: PayloadAction<boolean>) => {
            state.isApplying = payload
        },
        setAutoScaleNamesApplying: (state, { payload }: PayloadAction<boolean>) => {
            state.isApplyingNames = payload
        },
        toggleAutoScaleDimensions: (state) => {
            state.dimensionsVisible = !state.dimensionsVisible
        },
        resetAutoScale: () => initialAutoScaleState,
    },
})

export const {
    setAutoScalePageView,
    setAutoScaleApplying,
    setAutoScaleNamesApplying,
    toggleAutoScaleDimensions,
    resetAutoScale,
} = autoScaleSlice.actions

export const selectAutoScalePageView = (state: RootState): PageScaleView | null => state.IMUP.autoScale.pageView

export const selectIsAutoScaleApplying = (state: RootState): boolean => state.IMUP.autoScale.isApplying

export const selectIsAutoScaleApplyingNames = (state: RootState): boolean => state.IMUP.autoScale.isApplyingNames

export const selectAreAutoScaleDimensionsVisible = (state: RootState): boolean => state.IMUP.autoScale.dimensionsVisible

export default autoScaleSlice
